<template>
  <v-card class="work-and-study-rights mt-3 elevation-4">
    <v-card-title class="title">Work and Study Rights</v-card-title>

    <v-card-text class="px-0">
      <table class="v-table theme--dark">
        <tbody>
          <tr>
            <th>Work Rights</th>
            <td>
              <v-chip v-for="right in profile.workRights" :key="right.id"
                      avatar :close="$can('edit', 'Profile')" @input="remove('work_rights', right.id)">
                <v-avatar>
                  <img :class="`flag-icon-background flag-icon-squared flag-icon-${right.countryCode.toLowerCase()}`" style="padding: 16px" />
                </v-avatar>
                {{ right.country }}
              </v-chip>
            </td>
            <td class="text-xs-right">
              <can I="edit" a="Profile">
                <v-menu offset-x :close-on-content-click="false" v-model="addingWorkRights">
                  <v-btn small flat fab slot="activator" color="secondary">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                  <v-list>
                    <v-list-tile>
                      <v-autocomplete
                        label="Country"
                        v-model="workRights"
                        @input="addWorkRight"
                        return-object
                        :items="countries"
                        item-text="name"
                      />
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </can>
            </td>
          </tr>
          <tr>
            <th>Study Rights</th>
            <td>
              <v-chip v-for="right in profile.studyRights" :key="right.id"
                      avatar :close="$can('edit', 'Profile')" @input="remove('study_rights', right.id)">
                <v-avatar>
                  <img :class="`flag-icon-background flag-icon-squared flag-icon-${right.countryCode.toLowerCase()}`" style="padding: 16px" />
                </v-avatar>
                {{ right.country }}
              </v-chip>
            </td>
            <td class="text-xs-right">
              <can I="edit" a="Profile">
                <v-menu offset-x :close-on-content-click="false" v-model="addingStudyRights">
                  <v-btn small flat fab slot="activator" color="secondary">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                  <v-list>
                    <v-list-tile>
                      <v-autocomplete
                        label="Country"
                        v-model="studyRights"
                        @input="addStudyRight"
                        return-object
                        :items="countries"
                        item-text="name"
                      />
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </can>
            </td>
          </tr>
        </tbody>
      </table>
    </v-card-text>
  </v-card>
</template>

<script>
// Helpers
import { mapGetters } from 'vuex'

// Data
import countries from '@/data/countries'

// Vue Components
export default {
  data() {
    return {
      countries,
      workRights: [],
      addingWorkRights: false,
      studyRights: [],
      addingStudyRights: false,
    }
  },
  computed: mapGetters({ profile: 'admin/profiles/find' }),
  methods: {
    remove(type, id) {
      if (type === 'work_rights') {
        this.$store.dispatch('admin/workRights/destroy', id).then(
          // Success
          () => {
            this.$store.commit('snackbar', {
              text: 'Work right was deleted successfully',
              type: 'success',
            })
            this.$store.dispatch('admin/profiles/fetch', this.profile.id)
          }
        )
      } else if (type === 'study_rights') {
        this.$store.dispatch('admin/studyRights/destroy', id).then(
          // Success
          () => {
            this.$store.commit('snackbar', {
              text: 'Study right was deleted successfully',
              type: 'success',
            })
            this.$store.dispatch('admin/profiles/fetch', this.profile.id)
          }
        )
      }
    },
    addWorkRight(country) {
      this.$store
        .dispatch('admin/workRights/create', {
          profile: { id: this.profile.id },
          country: country.name,
          countryCode: country.code,
        })
        .then(() => {
          this.addingWorkRights = false
          this.workRights = []
          this.$store.commit('snackbar', {
            text: 'Work right was added successfully',
            type: 'success',
          })
          this.$store.dispatch('admin/profiles/fetch', this.profile.id)
        })
    },
    addStudyRight(country) {
      this.$store
        .dispatch('admin/studyRights/create', {
          profile: { id: this.profile.id },
          country: country.name,
          countryCode: country.code,
        })
        .then(() => {
          this.addingStudyRights = false
          this.studyRights = []
          this.$store.commit('snackbar', {
            text: 'Study right was added successfully',
            type: 'success',
          })
          this.$store.dispatch('admin/profiles/fetch', this.profile.id)
        })
    },
  },
}
</script>
